// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"D0-z"};